import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=5d88fe28&"
import script from "./Scrollable.vue?vue&type=script&lang=js&"
export * from "./Scrollable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports